import { requireService, wrap } from '@repo/di-ez';
import { InfoLight } from '@repo/go-icons';
import { Button, Tooltip } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  disabled?: boolean;
};

export const TrajectoryListOpenButton = wrap<Props>(function TrajectoryListOpenButton({ className, disabled }) {
  const { t } = useTranslation();
  const uiStore = requireService('trajectoryUiStore');

  return (
    <Tooltip title={t('ListSidebar.openTooltip')} delay={400}>
      <Button
        className={className}
        size="s"
        variant="primary"
        icon={<InfoLight />}
        disabled={disabled}
        onClick={() => uiStore.setTrajectoryListOpen(true)}
      />
    </Tooltip>
  );
});
